

import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { AdminHeader } from '../admin-header/admin-header';
import { AdminSidebar } from '../admin-sidebar/admin-sidebar';

@Component({
  selector: 'app-ward',
  standalone: true,
  imports: [CommonModule, FormsModule, AdminHeader, AdminSidebar],
  templateUrl: './wards.html',
  styleUrls: ['./wards.css']
})
export class WardComponent implements OnInit {
  baseUrl = 'https://logs.proofile.com.ng/api/wards';

  wards: any[] = [];
  newWard: any = { name: '' };
  editingWard: any = null;

  constructor(private http: HttpClient) {}

  ngOnInit() {
    this.loadWards();
  }

  loadWards() {
    this.http.get<any[]>(this.baseUrl).subscribe(data => {
      this.wards = data;
    });
  }

  saveWard() {
    if (this.editingWard) {
      // Update existing ward
      this.http.put(`${this.baseUrl}/${this.editingWard.id}`, this.newWard).subscribe(() => {
        this.resetForm();
        this.loadWards();
      });
    } else {
      // Create new ward
      this.http.post(this.baseUrl, this.newWard).subscribe(() => {
        this.resetForm();
        this.loadWards();
      });
    }
  }

  editWard(ward: any) {
    this.editingWard = ward;
    this.newWard = { ...ward };
  }

  deleteWard(id: number) {
    if (confirm('Are you sure you want to delete this ward?')) {
      this.http.delete(`${this.baseUrl}/${id}`).subscribe(() => this.loadWards());
    }
  }

  resetForm() {
    this.newWard = { name: '' };
    this.editingWard = null;
  }
}
